import React, {useContext, useEffect, useState} from 'react';
import {authContext} from '../Context/Authentication/authContext';
import {
  Grid,
  Box,
  FormControl,
  Button,
  Slider,
  Typography,
  Divider,
  Chip
} from '@mui/material';
import {styled} from '@mui/material/styles';
import '../WhatIfAnalysis/WhatIfAnalysis.scss'
import {getSliderMarks, generateUniqueColors} from './healper'
import SendIcon from '@mui/icons-material/Send';
import {Bars} from 'react-loader-spinner';
import {otherBaseURL} from '../config';
import axios from 'axios';
import WareHouseMap from './Map/Map'

const VerticalSlider = styled(Slider)({
  marginLeft: '35%',
  color: '#fff',
  height: 100,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    // height: 24,
    // width: 24,
    backgroundColor: '#f7b047',
    border: '2px solid #f7b047',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '&.Mui-disabled .MuiSlider-thumb': {
    backgroundColor: '#a0a0a0',
    border: '2px solid #a0a0a0',
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    fontWeight: 600,
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    background: 'linear-gradient(#fab144 -49.88%, rgba(255, 168, 13, 0.1) 102.13%)',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    left: 'calc(-50% + 4px)',
    '&:before': {display: 'none'},
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
  '& .MuiSlider-markLabel': {
    color: '#f7b047',
  },
});

const WarehouseSelection = () => {
  const {state}: any = useContext(authContext);
  const [isLoading, setLoading]: any = useState(false)
  const [showMap, setShowMap]: any = useState(false)
  const [geoData, setGeoData] = useState({});
  const [chartData, setChartData] = useState([]);
  const [markers, setMarkers] = useState([]);
  const [colors, setColors] = useState([]);
  const [sliderValues, setSliderValues]: any = useState({
    distance: 100,
    householdsPerUnit: 10000,
    transportCost: 5,
    loadTruckSpace: 250,
    emiFraction: 0.75,
    operatingCost: 0.5,
    transportGoodsWorth: 100000,
    profitFraction: 3,
    constructionCost: 100,
    minZipCodes: 20,
    maxDistance: 125
  });

  useEffect(() => {
    setShowMap(false)
    setGeoData({})
    setChartData([])
    setMarkers([])
    setColors([])
  }, [state?.filters?.state])

  const sliderChange = (event: any, newValue: number | number[]) => {
    sliderValues[event.target.name] = newValue
    setSliderValues({...sliderValues})
    event.preventDefault()
  };


  const handleSubmit = async () => {
    setLoading(true)
    setShowMap(false)
    let {
      distance,
      householdsPerUnit,
      transportCost,
      loadTruckSpace,
      emiFraction,
      operatingCost,
      transportGoodsWorth,
      profitFraction,
      constructionCost,
      minZipCodes,
      maxDistance
    } = sliderValues

    emiFraction = emiFraction / 100
    profitFraction = profitFraction / 100

    const response = await axios.get(
      `${otherBaseURL}warehouseSelection/${state?.filters?.state}/${distance}/${loadTruckSpace}/${operatingCost}/${profitFraction}/${householdsPerUnit}/${minZipCodes}/${transportCost}/${transportGoodsWorth}/${maxDistance}/${constructionCost}/${emiFraction}`
    );
    const data = response.data.sort((a: any, b: any) => a.Warehouse_zip_code_id - b.Warehouse_zip_code_id)
    let info = []
    let allZipCodes: any = []
    for (const d of data) {
      let className = 'green'
      if (d.pref === 'second') className = 'blue'
      else if (d.pref === 'third') className = 'red'
      info.push({
        warehouseZipcodeId: d.Warehouse_zip_code_id,
        pref: d.pref,
        zipcode: d['zip code'],
        investment: d['investment($)'],
        expectedProfit: d['expected_profit($)'],
        expectedPercentage: d.expected_percent_of_retrns_per_month,
        expectedTruckLoad: d.expected_truck_loads_transport_per_month,
        coveredHousehold: d.covered_house_holds,
        coveredZipcode: d.covered_no_of_zip_codes,
        className,
        cluster: parseInt(d.Warehouse_zip_code_id),
        position: {lat: parseFloat(d.lat), lng: parseFloat(d.long)}
      })
      // @ts-ignore
      allZipCodes = [...allZipCodes, ...d.covered_zip_codes]
    }
    // @ts-ignore
    allZipCodes = [...new Set(allZipCodes)]
    // @ts-ignore
    setMarkers(info)
    setChartData(data)

    const colorRange = generateUniqueColors(data.length / 3)
    // @ts-ignore
    setColors(colorRange)

    const key = state?.filters?.state.toLowerCase()
    console.log(key)
    const geoLocationInfo = await getGeoJSONInfo(key, allZipCodes)
    setGeoData(geoLocationInfo)
    setLoading(false)
    setShowMap(true)
  }

  const getGeoJSONInfo = async (key: string) => {
    let resp;
    let data = {};
    resp = await fetch(`../fullgeoJsonData/${key}.json`);
    data = await resp.json();

    return data;
  };


  return (
    <>
      <div className='what-if-container'>
        <div className='what-if-container__heading'>
          Warehouse Selection
        </div>
        <div className='what-if-container__row'>
          <Box sx={{flexGrow: 1}}>
            <Grid container spacing={.5} style={{flexGrow: 1}}>
              <Grid item xs={1}>
                <VerticalSlider
                  key={'distance'}
                  id={'distance'}
                  valueLabelDisplay={'on'}
                  aria-label={'distance'}
                  orientation='vertical'
                  name={'distance'}
                  value={sliderValues.distance}
                  marks={getSliderMarks(50, 500)}
                  step={10}
                  min={50}
                  max={500}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>Distance (Miles)</Typography>
              </Grid>
              <Grid item xs={1.1}>
                <VerticalSlider
                  key={'maxDistance'}
                  id={'maxDistance'}
                  valueLabelDisplay={'on'}
                  aria-label={'maxDistance'}
                  orientation='vertical'
                  name={'maxDistance'}
                  value={sliderValues.maxDistance}
                  marks={getSliderMarks(50, 500)}
                  step={10}
                  min={50}
                  max={500}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>Max Distance(Miles)</Typography>
              </Grid>
              <Grid item xs={1.1}>
                <VerticalSlider
                  key={'householdsPerUnit'}
                  id={'householdsPerUnit'}
                  valueLabelDisplay={'on'}
                  aria-label={'householdsPerUnit'}
                  orientation='vertical'
                  name={'householdsPerUnit'}
                  value={sliderValues.householdsPerUnit}
                  marks={getSliderMarks(10000, 200000)}
                  step={1000}
                  min={10000}
                  max={200000}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>Households Per Unit</Typography>
              </Grid>
              <Grid item xs={1.1}>
                <VerticalSlider
                  key={'transportCost'}
                  id={'transportCost'}
                  valueLabelDisplay={'on'}
                  aria-label={'transportCost'}
                  orientation='vertical'
                  name={'transportCost'}
                  value={sliderValues.transportCost}
                  marks={getSliderMarks(2, 10)}
                  step={0.25}
                  min={2}
                  max={10}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>Transport Cost Per Mile ($)</Typography>
              </Grid>
              <Grid item xs={1.1}>
                <VerticalSlider
                  key={'loadTruckSpace'}
                  id={'loadTruckSpace'}
                  valueLabelDisplay={'on'}
                  aria-label={'loadTruckSpace'}
                  orientation='vertical'
                  name={'loadTruckSpace'}
                  value={sliderValues.loadTruckSpace}
                  marks={getSliderMarks(50, 1000)}
                  step={50}
                  min={10}
                  max={1000}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>Space for 1 Truck Load (Sq.Ft)</Typography>
              </Grid>
              <Grid item xs={1.1}>
                <VerticalSlider
                  key={'emiFraction'}
                  id={'emiFraction'}
                  valueLabelDisplay={'on'}
                  aria-label={'emiFraction'}
                  orientation='vertical'
                  name={'emiFraction'}
                  value={sliderValues.emiFraction}
                  marks={getSliderMarks(0.2, 1.25)}
                  step={0.1}
                  min={0.2}
                  max={1.25}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>EMI Rer Month (Percentage On
                  Investment)</Typography>
              </Grid>
              <Grid item xs={1.1}>
                <VerticalSlider
                  key={'operatingCost'}
                  id={'operatingCost'}
                  valueLabelDisplay={'on'}
                  aria-label={'operatingCost'}
                  orientation='vertical'
                  name={'operatingCost'}
                  value={sliderValues.operatingCost}
                  marks={getSliderMarks(0.2, 2)}
                  step={0.01}
                  min={0.2}
                  max={2}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>Warehouse Operating Cost Per Sq.Ft Per Month
                  ($)</Typography>
              </Grid>
              <Grid item xs={1.1}>
                <VerticalSlider
                  key={'transportGoodsWorth'}
                  id={'transportGoodsWorth'}
                  valueLabelDisplay={'on'}
                  aria-label={'transportGoodsWorth'}
                  orientation='vertical'
                  name={'transportGoodsWorth'}
                  value={sliderValues.transportGoodsWorth}
                  marks={getSliderMarks(10000, 500000)}
                  step={1000}
                  min={10000}
                  max={500000}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>One Truck Transport Goods Worth
                  ($)</Typography>
              </Grid>
              <Grid item xs={1.1}>
                <VerticalSlider
                  key={'profitFraction'}
                  id={'profitFraction'}
                  valueLabelDisplay={'on'}
                  aria-label={'profitFraction'}
                  orientation='vertical'
                  name={'profitFraction'}
                  value={sliderValues.profitFraction}
                  marks={getSliderMarks(1, 100)}
                  step={0.25}
                  min={1}
                  max={100}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>Profit Margin On Goods (%)</Typography>
              </Grid>
              <Grid item xs={1.1}>
                <VerticalSlider
                  key={'constructionCost'}
                  id={'constructionCost'}
                  valueLabelDisplay={'on'}
                  aria-label={'constructionCost'}
                  orientation='vertical'
                  name={'constructionCost'}
                  value={sliderValues.constructionCost}
                  marks={getSliderMarks(50, 500)}
                  step={10}
                  min={50}
                  max={500}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>Construction Cost Per SqFt ($)</Typography>
              </Grid>
              <Grid item xs={1.1}>
                <VerticalSlider
                  key={'minZipCodes'}
                  id={'minZipCodes'}
                  valueLabelDisplay={'on'}
                  aria-label={'minZipCodes'}
                  orientation='vertical'
                  name={'minZipCodes'}
                  value={sliderValues.minZipCodes}
                  marks={getSliderMarks(5, 50)}
                  step={5}
                  min={5}
                  max={50}
                  onChange={sliderChange}
                />
                <Typography gutterBottom className={'slider-typography'}>Minimum Zipcodes</Typography>
              </Grid>

            </Grid>
            <Grid container spacing={2}>
              <Grid item xs={9}>
                {showMap && (
                  <>
                    <div className={'legend'}>
                      {colors.map((color: any, index: number) => (
                        <div className={'legend-item'} key={'legend-item-' + index.toString()}>
                          <div className={'legend-box'} style={{backgroundColor: color}}/>
                          <span>Warehouse {index + 1}</span>
                        </div>
                      ))}
                    </div>
                    <Divider component='li'>
                      <Chip label='Warehouse Preferences' size="small"/>
                    </Divider>
                    <div className={'legend'}>
                      <div className={'legend-item'}>
                        <div className={'legend-box'} style={{backgroundColor: '#00E64C'}}/>
                        <span>First Preference</span>
                      </div>
                      <div className={'legend-item'}>
                        <div className={'legend-box'} style={{backgroundColor: '#6991FD'}}/>
                        <span>Second Preference</span>
                      </div>
                      <div className={'legend-item'}>
                        <div className={'legend-box'} style={{backgroundColor: '#FD7567'}}></div>
                        <span>Third Preference</span>
                      </div>
                    </div>
                  </>
                )}
              </Grid>
              <Grid item xs={2.5}>
                <FormControl fullWidth variant='standard'>
                  <Button
                    className='run-analysis-multi'
                    size='large'
                    endIcon={<SendIcon/>}
                    onClick={handleSubmit}
                    disabled={isLoading}
                  >
                    Run Analysis
                  </Button>
                </FormControl>
              </Grid>
              <Grid item xs={.5}/>
            </Grid>
          </Box>
        </div>
        <div className={'map-container'}>
          {
            isLoading
              ?
              <Bars height='200' ariaLabel='bars-loading' wrapperClass='spinner-progress-bar warehouse-spinner-position'
                    visible={true}/>
              : (
                showMap ?
                  <WareHouseMap
                    mapData={chartData}
                    geoData={geoData}
                    markers={markers}
                    colors={colors}
                  /> : ''
              )
          }
        </div>
      </div>
    </>
  )

}

export default WarehouseSelection;
